import http from '@/http'

const API_PATH = 'organizations/:organizationId/video_room_masters/:videoRoomMasterId/video_rooms/:videoRoomId/video_room_members/'

const configureApiPath = ({ organizationId, videoRoomMasterId, videoRoomId }) => {
  return API_PATH.replace(':organizationId', organizationId)
                 .replace(':videoRoomMasterId', videoRoomMasterId)
                 .replace(':videoRoomId', videoRoomId)
}

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  // NOTE: ゲスト招待のみで使用
  async create({ commit, rootGetters }, payload) {
    const { videoRoomMasterId, videoRoomId, attributes } = payload
    const apiPath = configureApiPath({
      organizationId: rootGetters['auth/currentOrganization'].id,
      videoRoomMasterId: videoRoomMasterId,
      videoRoomId: videoRoomId
    })
    const params = JSON.stringify({
      videoRoomMember: {
        guestUser: attributes
      }
    })
    await http.post(apiPath, params).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  // NOTE: 会議室内でのreEnter処理
  async update({ commit, rootGetters }, payload) {
    const { videoRoomMasterId, videoRoomId, id, attributes } = payload
    const apiPath = configureApiPath({
      organizationId: rootGetters['auth/currentOrganization'].id,
      videoRoomMasterId: videoRoomMasterId,
      videoRoomId: videoRoomId
    })
    const params = JSON.stringify({
      videoRoomMember: attributes
    })
    await http.put(apiPath + id, params).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
